import apiClient, { ApiResponse } from './client';

export interface SlackConfig {
  connected: boolean;
  slack_team_name: string | null;
  notification_channel_name: string | null;
  notify_on_qualified: boolean;
  notify_on_booked: boolean;
  notify_on_high_intent: boolean;
  notify_on_all_calls: boolean;
  notify_on_active_session: boolean;
}

export interface UpdateSlackNotifications {
  notify_on_qualified?: boolean;
  notify_on_booked?: boolean;
  notify_on_high_intent?: boolean;
  notify_on_all_calls?: boolean;
  notify_on_active_session?: boolean;
}

export class SlackService {
  getInstallUrl(organizationId: string, userId?: string): string {
    const base = apiClient.getBaseUrl();
    const params = new URLSearchParams({ organization_id: organizationId });
    if (userId) params.set('user_id', userId);
    return `${base}/api/slack/install?${params.toString()}`;
  }

  async getConfig(organizationId: string): Promise<ApiResponse<SlackConfig>> {
    return apiClient.get<SlackConfig>('/api/slack/config', { organization_id: organizationId });
  }

  async updateNotifications(organizationId: string, data: UpdateSlackNotifications): Promise<ApiResponse<SlackConfig>> {
    return apiClient.put<SlackConfig>(`/api/slack/config/notifications?organization_id=${encodeURIComponent(organizationId)}`, data);
  }

  async disconnect(organizationId: string): Promise<ApiResponse<{ message: string }>> {
    return apiClient.delete<{ message: string }>(`/api/slack/disconnect?organization_id=${encodeURIComponent(organizationId)}`);
  }
}

const slackService = new SlackService();
export default slackService;
